import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuMySubscriptionsFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 4.00098C23.1046 4.00098 24 4.89641 24 6.00098V12.4541C24 13.4492 23.6293 14.4092 22.96 15.1455L19.7354 18.6914C18.9774 19.5252 17.9032 20.0009 16.7764 20.001H2C0.895431 20.001 0 19.1055 0 18.001V6.00098C0 4.89641 0.895431 4.00098 2 4.00098H22ZM5 7.00098C3.89543 7.00098 3 7.89641 3 9.00098V15.001C3 16.1055 3.89543 17.001 5 17.001H11C12.1046 17.001 13 16.1055 13 15.001V9.00098C13 7.89641 12.1046 7.00098 11 7.00098H5Z",
		fill: "#311123"
	})
});
export default SvgMenuMySubscriptionsFilled;
